import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";
import { TableBody, TableRow, TableCell } from "@mui/material";
import axios from "axios";
import useTableScroll from "../components/useTableScrollcesar.js";
const op = require("../modulos/datos.js");

const CatalogoCuentaContableBienes = ({ show, desde, onHide }) => {
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtCodigo = useRef([]);
  const txtBuscar = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [listaClasificador, setListaClasificador] = useState([]);
  const [clasificadorTodos, setClasificadorTodos] = useState([]);
  let values = {
    codigocuenta: "",
    descripcion: "",
    idcuentacontable: ""
  };

  const headCells = [
    { label: "Codigo", textAlign: "center" },
    { label: "Descripcion", textAlign: "center" },
    { label: "ID", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);
  const handleSearch = (e) => {
    let target = e.target;
    let lista = [];

    if (target.value === "") {
      lista = clasificadorTodos;
    } else {
      lista = clasificadorTodos.filter((x) => {
        if (
          x.idcuentacontable.includes(target.value) ||
          x.codigocuenta.toLowerCase().includes(target.value.toLowerCase()) ||
          x.descripcion.toLowerCase().includes(target.value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setListaClasificador(lista);
  };

  const seleccionarRegistros = () => {

    const endpoint = `${op.conexion}/api/bienes/clasificador/seleccionar_ctaconta4?idefiscal=${idefiscal}&desde=${desde}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          console.log(response.data);
          
          if (response.data.length > 0) {
            setListaClasificador(response.data);
            setClasificadorTodos(response.data);
          } else {
            setListaClasificador([]);
            setClasificadorTodos([]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setListaClasificador([]);
    setClasificadorTodos([]);
    values = {
    codigocuenta: "",
    descripcion: "",
    idcuentacontable: ""
    };
  };

  const seleccionarFila = (item, index) => {
    values = {
    codigocuenta: item.codigocuenta,
    descripcion: item.descripcion,
    idcuentacontable: item.idcuentacontable
    };

    for (let i = 0; i < txtCodigo.current.length; i++) {
      if (i === index) {
        txtCodigo.current[i].style.backgroundColor = "lightskyblue";
      } else {
        if (txtCodigo.current[i]) {
          txtCodigo.current[i].style.backgroundColor = "white";
        }
      }
    }

    btnAcepta.current.focus();
  };

  const cancelar = () => {
    blanquear();
    onHide();
  };

  const seleccionar = () => {
    onHide(values);
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Catalogo Cuentas Contable</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} />
        <div className="row col-md-12" style={{ marginBottom: "10px" }}>
          <div className="input-group m-0 col-md-6 input-group-sm mb-3">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control text-uppercase"
              ref={txtBuscar}
            />
            <button className="btn btn-info" style={{ pointerEvents: "none" }}>
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer
            container={{
              height: 200,
              width: "100%",
              overflow: "auto",
              padding: "2px",
              fontSizeAdjust: "0.6",
            }}
          >
            <TblHead />

            <TableBody>
              {listaClasificador &&
                listaClasificador.map((item, index) => (
                  <TableRow
                    key={index}
                    ref={(el) => (txtCodigo.current[index] = el)}
                    style={{ backgroundColor: "white" }}
                    onClick={() => seleccionarFila(item, index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.codigocuenta.trim()}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.descripcion.trim()}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.idcuentacontable}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          {/*           <TblPagination /> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionar}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoCuentaContableBienes;
